"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getOverlayStyles = exports.getContentStyles = exports.TopSection = exports.StyledLink = exports.StyledButton = exports.ContentWrapper = exports.BottomSection = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _palette = require("../../styles/palette");
var _colorUtils = require("../../utils/color-utils");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var getContentStyles = exports.getContentStyles = function getContentStyles() {
  return {
    border: 0,
    borderRadius: 4,
    top: 'auto',
    boxShadow: ['0 24px 38px rgba(0, 0, 0, 0.14)', '0 9px 46px rgba(0, 0, 0, 0.12)', '0 11px 15px rgba(0, 0, 0, 0.2)'].join(),
    display: 'flex',
    flexDirection: 'column',
    left: '50%',
    padding: 24,
    position: 'fixed',
    right: 'auto',
    bottom: '0px',
    transform: 'translate(-50%, -50%)',
    overflow: 'none',
    width: '90%',
    maxWidth: '720px'
  };
};
var getOverlayStyles = exports.getOverlayStyles = function getOverlayStyles() {
  return {
    backgroundColor: 'none',
    height: 0,
    width: 0
  };
};
var StyledLink = exports.StyledLink = _styledComponents["default"].a.withConfig({
  displayName: "styles__StyledLink",
  componentId: "sc-xyrkov-0"
})(["color:inherit;font-weigth:600;text-decoration:underline;text-underline-offset:3px;&:hover{color:", ";text-decoration:underline;text-underline-offset:3px;}"], _palette.commonPalette.txBlack);
var ContentWrapper = exports.ContentWrapper = _styledComponents["default"].div.withConfig({
  displayName: "styles__ContentWrapper",
  componentId: "sc-xyrkov-1"
})(["display:flex;flex-direction:column;font-size:14px;"]);
var TopSection = exports.TopSection = _styledComponents["default"].div.withConfig({
  displayName: "styles__TopSection",
  componentId: "sc-xyrkov-2"
})(["width:", "%;", ""], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? '100' : '85';
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? 'margin-bottom: 10px;' : '';
});
var BottomSection = exports.BottomSection = _styledComponents["default"].div.withConfig({
  displayName: "styles__BottomSection",
  componentId: "sc-xyrkov-3"
})(["flex:1;display:flex;justify-content:space-between;align-items:flex-end;"]);
var StyledButton = exports.StyledButton = _styledComponents["default"].a.withConfig({
  displayName: "styles__StyledButton",
  componentId: "sc-xyrkov-4"
})(["color:", ";background:", ";padding:10px 20px;text-decoration:none;border-radius:4px;text-align:center;min-width:92.75px;min-height:40px;display:inline-block;position:relative;&:hover{color:", ";background:", ";}&:link{text-decoration:none;}"], _palette.commonPalette.white, function (_ref3) {
  var disabled = _ref3.disabled;
  return disabled ? _palette.commonPalette.lightGreen : _palette.commonPalette.sgGreen;
}, _palette.commonPalette.white, function (_ref4) {
  var disabled = _ref4.disabled;
  return disabled ? _palette.commonPalette.lightGreen : (0, _colorUtils.darken)(_palette.commonPalette.sgGreen, 0.15);
});
//# sourceMappingURL=styles.js.map